<!--
 * @Author: czj
 * @Date: 2025-04-12 16:28:57
 * @Description: 
 * @FilePath: \test-demo2\src\components\ComparisonGroup\index.vue
-->
<template>
  <div>
    <!-- 分组表格 -->
    <div v-if="compare_group && compare_plan" class="group_data_table_container">
      <el-table :data="compare_group" style="width: 100%" :height="500">
        <el-table-column v-for="col in compare_group_columns" :key="col" :prop="col" :label="col" align="center" />
      </el-table>
    </div>

    <!-- 方案表格 -->
    <div v-if="compare_group && compare_plan" class="group_data_table_container">
      <el-table :data="compare_plan" style="width: 100%" :height="500">
        <el-table-column v-for="col in plan_data.columns" :key="col" :prop="col" :label="col" align="center" />
      </el-table>
    </div>

    <!-- 分组设置 -->
    <el-dialog title="分组设置" v-model="is_group_dialog" width="80%" :close-on-click-modal="false">
      <SampleGroup v-if="is_group_dialog" ref="sampleGroups" :rawData="compare_group" :configData="configData"
        @updateCompareGroup="updateCompareGroup" />
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="is_group_dialog = false">取消</el-button>
          <el-button type="primary" @click="handleSaveGroup">确定</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 方案设置 -->
    <el-dialog title="比较方案" v-model="is_plan_dialog" width="80%" top="50px" :close-on-click-modal="false">
      <ComparePlan v-if="is_plan_dialog" ref="comparePlan" :rawData="compare_group" :compareData="compare_plan"
        :configData="configData" @updateComparePlan="updateComparePlan" />
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="is_plan_dialog = false">取消</el-button>
          <el-button type="primary" @click="handleSavePlan">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
  /** =======================
   *  Imports
   * ======================= */
  import { ref, computed, defineProps, watch, onBeforeMount, onMounted, defineEmits } from "vue";
  import { ElMessage } from "element-plus";
  import { get_file_data, write_file_data } from "@/api/index.js";
  import { transformToCascaderData } from "@/utils/tool.js";

  import SampleGroup from "./SampleGroup.vue";
  import ComparePlan from "./ComparePlan.vue";

  /** =======================
   *  Props & Emits
   * ======================= */
  const emit = defineEmits([]);
  const props = defineProps(["data", "task_result", "file_data"]);

  /** =======================
   *  State
   * ======================= */
  const tableData = ref(null);
  const table_data = ref(null);
  const plan_data = ref(null);



  const compare_group = ref(null);
  const compare_group_columns = ref(null);


  const compare_plan = ref(null);

  const readOnly = ref(false);

  const configData = ref({
    group_mapping: {
      sample_id: "companyCode",
      group: "group",
      samplename: "samplename"
    },
    group_config: { min_count: 1, max_count: 3 },
    plan_mapping: { label: "label", value: "tag", method: "function1" },
    plan_config: {
      methods: [
        { label: "方法1", value: "method1", max_count: 2 },
        { label: "方法2", value: "method2", max_count: 3 }
      ]
    }
  });

  const is_group_dialog = ref(false);
  const is_plan_dialog = ref(false);

  const group_data_id = ref(null);
  const plan_data_id = ref(null);

  const control_file_path = ref("");
  const metadata_file_path = ref("");

  const sampleGroups = ref(null);
  const comparePlan = ref(null);

  const raw_data = ref(null);

  let node_data_token = null;
  let group_setting_token = null;

  /** =======================
   *  Common Helpers
   * ======================= */
  const getTableData = (raw) => {
    if (!raw) return [];
    const { columns, data } = raw;
    return data.map((row) =>
      row.reduce((obj, cell, i) => {
        obj[columns[i]] = cell;
        return obj;
      }, {})
    );
  };

  const getTableData11 = (raw) => {
    console.log("原始分组数据", raw);

    // 1. 基础校验：确保 raw 及其内部数据有效
    if (!raw || !Array.isArray(raw.columns) || !Array.isArray(raw.data)) {
      return [];
    }

    const { columns, data } = raw;

    // 2. 查找 "is_selected" 的位置。如果不存在，indexOf 会返回 -1
    const selectedIdx = columns.indexOf("is_selected");
    const hasSelectedCol = selectedIdx !== -1;

    return data
      // 3. 过滤逻辑：只有当存在该列时，才执行 true 的过滤；否则保留所有数据
      .filter((row) => {
        if (!hasSelectedCol) return true; // 如果没有这一列，默认全部显示
        return row[selectedIdx] === true;
      })
      // 4. 转换逻辑
      .map((row) =>
        row.reduce((obj, cell, i) => {
          const columnName = columns[i];
          // 5. 排除逻辑：只有当当前索引是 "is_selected" 时才跳过
          if (i !== selectedIdx) {
            obj[columnName] = cell;
          }
          return obj;
        }, {})
      );
  };

  const convertToTableFormat = (arr, columns) => ({
    columns,
    data: arr.map((item) => columns.map((col) => item[col]))
  });

  /** =======================
   *  文件读取/写入
   * ======================= */
  const readFileByPath = (path, type) => {
    const params = {
      callback_name: "file_path",
      file_path: path,
      callback_function: { file_format: "table" }
    };
    get_file_data(params).then((res) => {
      const out = res.data;
      if (type === "group") {
        table_data.value = out;
        compare_group.value = getTableData(out);

        // 如果存在 "is_selected"，就去掉
        compare_group_columns.value = out.columns.filter(col => col !== "is_selected");
      } else {
        plan_data.value = out;
        compare_plan.value = getTableData(out);
      }
    })
      .catch((err) => console.error("读取文件失败", err));
  };

  const updateFileData = (path, data) => {
    const params = {
      callback_name: "file_path",
      file_path: path,
      callback_function: { type: "table" },
      data
    };
    write_file_data(params).then((res) => {
      if (res.code === 200) ElMessage.success("更新成功");
    });
  };

  /** =======================
   *  Dialog Handling
   * ======================= */
  const openGroupDialog = () => {
    compare_group.value = getTableData(table_data.value);
    is_group_dialog.value = true;
  };

  const openPlanDialog = () => {
    compare_group.value = getTableData(table_data.value);
    compare_plan.value = getTableData(plan_data.value);
    is_plan_dialog.value = true;
  };

  /** =======================
   *  Save Handling
   * ======================= */
  const handleSaveGroup = () => sampleGroups.value?.updateHandle();
  const handleSavePlan = () => comparePlan.value?.updateHandle();

  const updateCompareGroup = (data) => {
    compare_group.value = data;
    const result = convertToTableFormat(data, table_data.value.columns);
    table_data.value = result;
    updateFileData(metadata_file_path.value, result);
    is_group_dialog.value = false;
  };

  const updateComparePlan = (data) => {
    const result = convertToTableFormat(data, plan_data.value.columns);
    plan_data.value = result;
    updateFileData(control_file_path.value, result);
    is_plan_dialog.value = false;
  };

  /** =======================
   *  初始化主数据
   * ======================= */
  const initByNodeResult = (node_result) => {
    if (!node_result) return;
    raw_data.value.process_report[0].default_val = node_result.data;
    const { control, metadata } = node_result.data;
    // --- 对象直接使用 ---
    if (control.columns && typeof metadata.columns) {
      table_data.value = metadata;
      plan_data.value = control;
      compare_group.value = getTableData(metadata);
      compare_plan.value = getTableData(control);
    } else if (typeof control === "string" && typeof metadata === "string") {
      // --- 文件路径 ---
      control_file_path.value = control;
      metadata_file_path.value = metadata;
      readFileByPath(metadata, "group");
      readFileByPath(control, "plan");
    }

    /*  if (node_result.select_data)
       cascader_options.value = transformToCascaderData(node_result.select_data); */
  };

  /** =======================
   *  Watch props.task_result
   * ======================= */
  watch(() => props.task_result, (newData) => {
    if (!newData) return;
    const title = props.data.title;
    initByNodeResult(newData[title]);
  });

  /** =======================
   *  Lifecycle
   * ======================= */
  onBeforeMount(() => {
    raw_data.value = JSON.parse(JSON.stringify(props.data));

    if (props.data) {
      readOnly.value = true;
    } else if (props.file_data) {
      readOnly.value = false;
    }

    group_data_id.value = `group_data_${props.data?.id}`;
    plan_data_id.value = `plan_data_${props.data?.id}`;
  });

  /*  onMounted(() => {
     if (props.data) {
       console.log("props.data", props.data);
       
       configData.value = JSON.parse(props.data.process_report[0].extend_json);
 
       initByNodeResult(props.task_result?.[props.data.title]);
 
       // PubSub 监听
       node_data_token = PubSub.subscribe(props.data.title, (msg, data) => {
         initByNodeResult(data.result);
       });
     }
 
     // 分组 or 方案设置事件
     group_setting_token = PubSub.subscribe("group_setting", (msg, data) => {
       if (data.type === "group") openGroupDialog();
       else if (data.type === "comparison") openPlanDialog();
     });
   }); */


  onMounted(() => {
    if (props.data) {
      console.log("props.data", props.data);

      // 解析 extend_json —— 安全、不会报错
      try {
        const extendJson = props.data?.process_report?.[0]?.extend_json;

        configData.value = extendJson ? JSON.parse(extendJson) : {};
      } catch (e) {
        console.error("extend_json 解析失败:", e);
        configData.value = {};
      }

      // 安全调用 initByNodeResult
      try {
        const key = props.data?.title;
        const nodeResult = key ? props.task_result?.[key] : null;

        if (nodeResult) {
          initByNodeResult(nodeResult);
        }
      } catch (e) {
        console.error("initByNodeResult 执行异常:", e);
      }

      // PubSub 监听
      node_data_token = PubSub.subscribe(props.data.title, (msg, data) => {
        try {
          initByNodeResult(data?.result);
        } catch (e) {
          console.error("node_data 处理异常:", e);
        }
      });
    }

    // 分组 or 方案设置事件
    group_setting_token = PubSub.subscribe("group_setting", (msg, data) => {
      if (data?.type === "group") openGroupDialog();
      else if (data?.type === "comparison") openPlanDialog();
    });
  });


</script>
<style lang="scss" scoped>
  .group_data_table_container {

    margin-bottom: 60px;

    :deep(.el-table th) {
      background-color: #FAFAFA;
      color: #333;
      border-bottom: none !important;
      height: 64px;

      .cell {
        font-size: 18px;
      }
    }

    :deep(.el-table th:first-child) {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }

    :deep(.el-table th:last-child) {
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }

    :deep(.el-table td) {
      padding-top: 26px;
      padding-bottom: 26px;

      .cell {
        color: #757D8A;
        font-size: 16px;
      }
    }
  }
</style>